import Dialog from './dialog'

Dialog.install = vue => {
  vue.component(Dialog.name, Dialog)
}

export default Dialog
